import React from "react";

const getDisplayName = (name) => {
  const reg = /_[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
  return name.replace(reg, "").replace("Refferal", "Referral");
};

const ReferralList = ({ referrals, activeReferral, onSelectReferral }) => {
  return (
    <div
      style={{ overflowY: "scroll", overflowX: "hidden", height: "calc(100vh - 330px)" }}
      className="panel is-link is-radiusless is-shadowless"
    >
      {referrals.map((referral) => (
        <a
          href="/"
          className={`panel-block ${activeReferral?.id === referral.id ? "is-active" : ""}`}
          onClick={(event) => {
            event.preventDefault();
            onSelectReferral(referral);
          }}
          key={`${referral.id}`}
        >
          <span className="panel-icon">
            <i className="fas fa-info-circle" aria-hidden="true" />
          </span>
          <p
            className={`is-size-7 has-text-weight-semibold ${
              activeReferral?.id === referral.id ? "has-text-link" : ""
            }`}
          >
            {getDisplayName(referral.fileName)}
          </p>
        </a>
      ))}
    </div>
  );
};

export default ReferralList;
